import BillShip from '../../../../../components/AdminSettings/InvoiceDetails/BillShip';
import {
  billShipData,
  mainHeadData,
} from '../../../../../components/AdminSettings/InvoiceDetails/invoiceData';
import InvoiceFooter from '../../../../../components/AdminSettings/InvoiceDetails/InvoiceFooter';
import InvoiceTable from '../../../../../components/AdminSettings/InvoiceDetails/InvoiceTable';
import MainHead from '../../../../../components/AdminSettings/InvoiceDetails/MainHead';
import { SingleInvoicesStyled } from './style';

const SingleInvoice = () => {
  return (
    <SingleInvoicesStyled>
      {mainHeadData.map((item, idx) => (
        <MainHead key={idx} {...item} />
      ))}
      {billShipData.map((item, idx) => (
        <BillShip {...item} key={idx} />
      ))}
      <InvoiceTable />
      <InvoiceFooter />
    </SingleInvoicesStyled>
  );
};

export default SingleInvoice;
